import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { EscalationEffects } from './effects/escalation.effects';
import { escalationReducer } from './reducers/escalation.reducer';
import { selectEscalationTimerEntries } from './selectors/escalation.selector';
import { ESCALATION_FEATURE_KEY } from './escalation-collection.state';

/**
 * Registers the escalation feature slice. Timer entries are written to IndexedDB via the
 * generic persistence layer so they survive navigation and are rehydrated on boot by
 * `hydrateEscalationTimersOnInit$`. The `hydrated` flag in state prevents duplicate hydrations.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(ESCALATION_FEATURE_KEY, escalationReducer),
        EffectsModule.forFeature([EscalationEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: ESCALATION_FEATURE_KEY,
                persistSelector: selectEscalationTimerEntries,
            },
        },
    ],
})
export class EscalationStoreModule {}
